<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import CartsTable from './CartsTable';

export default {
  page: {
    title: 'Carts',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, CartsTable },
  data() {
    return {
      title: 'Carts',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Carts', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      }
    }
  },
  watch: {

  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <CartsTable ref="CartsTable" :listing="{}" :changefilters="filters" @loadchange="(e) => {loading = e; (!e ? changes = e : '')}"></CartsTable>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>
